export default __webpack_public_path__ + "static/media/mail_icon.1a5a6dcb.svg";